import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const IconEditOutlineGroup: React.FC<SvgProps> = (props) => {
  const strokeColor = toSvgColor('currentColor', props);

  return (
    <g {...(props.group ?? {})}>
      <path
        d="M15.3806 4.60932C15.7771 4.21288 15.9999 3.67516 16 3.11445C16.0001 2.55373 15.7774 2.01595 15.381 1.61942C14.9845 1.22288 14.4468 1.00007 13.8861 1C13.3254 0.99993 12.7876 1.22261 12.3911 1.61904L2.38146 11.6309C2.20733 11.8045 2.07855 12.0183 2.00646 12.2534L1.0157 15.5174C0.996317 15.5823 0.994853 15.6512 1.01146 15.7168C1.02808 15.7824 1.06214 15.8423 1.11005 15.8902C1.15796 15.938 1.21792 15.972 1.28357 15.9885C1.34923 16.005 1.41812 16.0034 1.48296 15.9839L4.74774 14.9939C4.98261 14.9225 5.19637 14.7945 5.37024 14.6212L15.3806 4.60932Z"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.75 3.25098L13.75 6.251"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  );
};

export const IconEditOutlineSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
    >
      <IconEditOutlineGroup {...props} />
    </svg>
  );
};
